import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';
import { IServerUser } from '../types/IServerUser';
import { IGetUsersParams } from './GetUsersRequest';

export interface IGetServerUsersParams extends IGetUsersParams {}

export interface IGetServerUsersResult extends IGetItemsResult {
  users: IServerUser[];
}

export class GetServerUsersRequest extends Request<IGetServerUsersParams, IGetServerUsersResult> {
  constructor(params: IGetServerUsersParams) {
    super('getServerUsers', params);
  }
}
